import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";
import "../css/simple-line-icons.css";
import Banner from "./banner";
import Welcome from "./welcome";
import MiddleBanner from "./middlebanner";
import BannerBottom from "./bannerBottom";
import Testimonial from "./testimonial";
import Gallery from "./gallery";
import { apiCalling } from "../apiService";
import {Helmet} from "react-helmet";
import Calender from "../healthTrackerCalender/health-trackers"

export default class home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: [],
      centreData: [],
      specialitiesData:[],
      missionData: [],
      bouquetData:[],
      //siteId: this.props.match.params.siteId,
    };
  }
  componentDidMount() {
    const bannerData = JSON.parse(window.sessionStorage.getItem("Banner"));
    const missionData = JSON.parse(window.sessionStorage.getItem("Mission"));
    const speciality = JSON.parse(window.sessionStorage.getItem("Specialities"));
    const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
    const Bouquet = JSON.parse(window.sessionStorage.getItem("Bouquet"));
    if (Centre) {
      this.setState({ centreData: Centre[0].sectionList});
    } if(speciality) {
      this.setState({ specialitiesData: speciality[0].sectionList});
    } 
    if(missionData) {
    this.setState({ missionData: missionData[0].sectionList});
    }
    if(bannerData) {
      this.setState({ bannerData: bannerData[0].sectionList});
      }
      if(Bouquet) {
        this.setState({ bouquetData: Bouquet[0].sectionList});
        }

    $(".booknow").hide();
    //window.sessionStorage.setItem("siteId", this.state.siteId);
    $(".layoutPatientMenuTop").hide();
    $(".layoutDoctorMenuTop").hide();
  }
  render() {
    window.onscroll = function () {
      myFunction();
    };
    function myFunction() {
      // var ff = $(".welcomeMain").position();
      // if (
      //document.body.scrollTop > ff.top ||
      // document.documentElement.scrollTop > ff.top
      // ) {
      //$(".booknow").show();
      // } else {
      //  $(".booknow").hide();
      // }
    }
    return (
      <div class="mentalHealthWrap mentalHealthWrapHome">
      <Helmet>
          <title>{window.sessionStorage.getItem("seo_title")}</title>        
          <meta name="description" content={window.sessionStorage.getItem("seo_description")} />
          <meta name="keywords" content={window.sessionStorage.getItem("seo_keywords")} ></meta>
          <meta name="twitter:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="twitter:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="twitter:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta name="facebook:title" content={window.sessionStorage.getItem("seo_title")}></meta>
          <meta name="facebook:description" content={window.sessionStorage.getItem("seo_description")}></meta>
          <meta name="facebook:image:src" content={window.sessionStorage.getItem("siteLogo")}></meta>
          <meta property="og:title" content={window.sessionStorage.getItem("seo_title")} ></meta>
          <meta property="og:image" content={window.sessionStorage.getItem("siteLogo")} ></meta>
          <meta property="og:description" content={window.sessionStorage.getItem("seo_description")} ></meta>
          <meta property="og:url" content={window.sessionStorage.getItem("slug")} ></meta>         
           
        </Helmet>

        <div class="metalContent">
        {this.state.bannerData.length > 0 ?
          <Banner></Banner>
          : ''}
          {this.state.missionData.length > 0 ?
          <div class="container">
            <BannerBottom></BannerBottom>
          </div>
            : ''}
          {this.state.specialitiesData.length > 0 ?
          <div class="container-fluid">
            <MiddleBanner></MiddleBanner> 
          </div>
           : ''}
          <div class="container-fluid p-0">
            <Welcome></Welcome>
          </div>
          {this.state.centreData.length > 0 ?
          <div class="container-fluid">
            <Testimonial></Testimonial>
          </div>
           : ''}
            {this.state.bouquetData.length > 0 ?
          <Gallery />
          : ''}
          {/* <div class="container"> */}
           

          {/* </div>  */}
          {/* <div class="container">
            <Specialist></Specialist>
          </div> */}
          {/* <Booknow></Booknow> */}
           {window.sessionStorage.getItem("hasHealthTracker")==='true' && ( 
                <Calender />
                 )} 
        </div>
      </div>
    );
  }
}
